module.exports = __webpack_public_path__ + "fonts/DroidSans.1e6485f.woff";